import type { GetTicketSearchFieldOptionsResponse } from 'Services/SalesManagement/Features/AffiliateProduct/types'
import { createBaseApi } from 'Util/ApiClient'

export const affiliateProductApi = createBaseApi({
  reducerPath: 'affiliateProductApi',
  keepUnusedDataFor: 10,
  tagTypes: []
}).injectEndpoints({
  endpoints: builder => ({
    getTicketSearchFieldOptions: builder.query<GetTicketSearchFieldOptionsResponse, void>({
      query: () => ({
        url: '/api/v1/transfer-management/',
        method: 'OPTIONS'
      })
    })
  })
})

export const { useGetTicketSearchFieldOptionsQuery } = affiliateProductApi
